import React from 'react';
import PerformanceReviewForm from '../hr/PerformanceReviewForm';

/** Employee opens assigned self-reviews here (edit when in progress). */
const MyPerformanceReviewView = () => <PerformanceReviewForm />;

export default MyPerformanceReviewView;
